import { NgModule } from '@angular/core';
import {CommonModule, DatePipe, NgFor, NgIf, NgSwitch, NgSwitchCase} from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOption, MatOptionModule, NativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatRow, MatRowDef, MatTable, MatTableModule} from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCommonModule } from '@angular/material/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { Cf2TopAppBarNgModule } from "@shared/components/top-bar-app/cf2.top-app-bar.ng.module";
import {DueDateDirective} from "@shared/directives/due-date.directive";
import {TranslocoDirective} from "@jsverse/transloco";
import {SpinnerDirective} from "@shared/directives/spinner.directive";
import { AutocompletePositionDirective } from '@shared/directives/autocomplete-position-directive';

const modules = [
    MatIcon,
    LayoutModule,
    NativeDateModule,
    MatGridListModule,
    MatButtonModule,
    Cf2TopAppBarNgModule,
    MatInputModule,
    MatDatepickerModule,
    MatRadioModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCardModule,
    MatNativeDateModule,
    MatDialogModule,
    MatBadgeModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatStepperModule,
    MatBottomSheetModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatTooltipModule,
    MatTable,
    MatTableModule,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    DueDateDirective,
    DatePipe,
    MatRow,
    MatHeaderRow,
    MatRowDef,
    MatInput,
    MatInputModule,
    MatOption,
    MatOptionModule,
    TranslocoDirective,
    SpinnerDirective,
    AutocompletePositionDirective,
    NgSwitch,
    NgSwitchCase,
    NgIf,
    NgFor,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...modules, MatCommonModule],
  exports: [
    modules,
    MatCommonModule
  ]
})
export class Cf2MaterialModule {}
